import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { AdminMetrics } from "../types/admin";

export const adminService = {
  async getDashboardMetrics(): Promise<AdminMetrics> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("get_admin_metrics");

    if (error) {
      throw error;
    }

    return (data ?? {}) as AdminMetrics;
  },
};
